"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Badge = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Transition = _interopRequireDefault(require("react-transition-group/Transition"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Base style of the badge.
 */
var defaultBaseStyles = {
  borderRadius: '50%',
  content: '',
  display: 'block',
  textAlign: 'center',
  userSelect: 'none'
  /**
   * Shadow style of the badge.
   */

};
var shadowStyles = {
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.65)'
  /**
   * Colored badge, optionally attached to some corner of its container.
   *
   * When the badge is meant to be attached to some corner of its container, the
   * container must be set to `position: relative` in CSS for the badge to work
   * nicely.
   */

};

var Badge = function Badge(_ref) {
  var anchor = _ref.anchor,
      animated = _ref.animated,
      children = _ref.children,
      color = _ref.color,
      offset = _ref.offset,
      shadow = _ref.shadow,
      size = _ref.size,
      style = _ref.style,
      visible = _ref.visible,
      rest = _objectWithoutProperties(_ref, ["anchor", "animated", "children", "color", "offset", "shadow", "size", "style", "visible"]);

  var baseStyles = _objectSpread({}, defaultBaseStyles, shadow ? shadowStyles : undefined, {
    background: color,
    fontSize: 10,
    lineHeight: size + 'px',
    minHeight: size,
    minWidth: size
  });

  if (anchor && (offset === null || offset === undefined)) {
    offset = [0, 0];
  }

  if (!Array.isArray(offset)) {
    offset = [offset, offset];
  }

  if (anchor === 'inline') {
    baseStyles.display = 'inline-block';
  } else {
    baseStyles.position = 'absolute';
  }

  if (offset) {
    switch (anchor) {
      case 'topLeft':
        baseStyles.top = offset[1];
        baseStyles.left = offset[0];
        break;

      case 'bottomLeft':
        baseStyles.bottom = offset[1];
        baseStyles.left = offset[0];
        break;

      case 'bottomRight':
        baseStyles.bottom = offset[1];
        baseStyles.right = offset[0];
        break;

      case 'topRight':
        baseStyles.top = offset[1];
        baseStyles.right = offset[0];
    }
  }

  if (animated) {
    return _react.default.createElement(_Transition.default, {
      appear: true,
      timeout: 300,
      in: visible
    }, function (state) {
      return _react.default.createElement("div", _extends({
        style: _objectSpread({}, baseStyles, {
          transform: state === 'entering' || state === 'entered' ? 'scale(1)' : 'scale(0)',
          transition: 'transform 300ms ease-in-out, background-color 300ms linear'
        }, style)
      }, rest), children);
    });
  } else {
    return visible ? _react.default.createElement("div", _extends({
      style: baseStyles
    }, rest), children) : null;
  }
};

exports.Badge = Badge;
Badge.propTypes = {
  anchor: _propTypes.default.oneOf(['inline', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight']),
  color: _propTypes.default.string,
  offset: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))]),
  size: _propTypes.default.number,
  style: _propTypes.default.object,
  visible: _propTypes.default.bool
};
Badge.defaultProps = {
  animated: true,
  anchor: 'topRight',
  color: 'red',
  offset: -3,
  shadow: true,
  size: 10,
  visible: true
};
var _default = Badge;
exports.default = _default;